(() => {
  function init(root = document) {
    const form = root.querySelector('#RjB2bForm');
    if (!form || form.dataset.enhanced) return;
    form.dataset.enhanced = 'true';
    const picks = document.querySelectorAll('[data-project-pick]');
    const outputs = document.querySelectorAll('[data-project-selection]');
    function sync() {
      const selected = [...picks].filter(input => input.checked).map(input => input.dataset.projectPick);
      outputs.forEach(output => { output.textContent = selected.length ? 'Med i din forespørgsel: ' + selected.join(' · ') : 'Vælg eventuelt møbler ovenfor – eller beskriv dit behov nedenfor.'; });
    }
    picks.forEach(input => input.addEventListener('change', sync));
    document.querySelectorAll('[data-project-type]').forEach(link => link.addEventListener('click', () => {
      form.elements['contact[projekttype]'].value = link.dataset.projectType;
    }));
    form.addEventListener('invalid', event => {
      const details = event.target.closest('details');
      if (details) details.open = true;
    }, true);
    sync();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
